import React, { Component } from 'react';
import { Text, View, Dimensions, Platform } from 'react-native';
import { Flex, Padding, Margin, Helpers, Typo, article, articleItem,FontFamily } from '../../styles/appStyles';
import ScrollContainerView from '../scroll-container-view';
import { helpers } from '../../utils/helpers';
import ArticleItemUserStory from '../article-item-user-story';
import Cookies from "universal-cookie";
import AuthenticationWrapper from '../authentication-wrapper';

const cookies = new Cookies();

export class HomeStoriesForYou extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        const {isAuthenticated, fetchToken} = this.props.auth
        let token = webView ? (process.browser ? (isAuthenticated?fetchToken:false) : this.props.token) : this.props.user?.userData?.data?.token;
        this.state = {
            showToken: (!helpers.isWeb() || process.browser) ? true : false,
        }
    }

    componentDidMount = () => {
    }

    viewMoreArticles = () => {
        const { viewAllArticles } = this.props;
        viewAllArticles()
    }

    viewArticle = (catSlug, slug, postData) => {
        const { viewArticle } = this.props;
        viewArticle(catSlug, slug, postData)
    }

    viewAuthor = (slug) => {
        const { viewAuthor } = this.props;
        viewAuthor(slug)
    }
    viewCategory = (slug) => {
        const { viewCategory } = this.props;
        viewCategory(slug)
    }

    render() {
        const { data } = this.props;
      
        return (
            
            <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWebFull]}>
                <View style={[article.headerWrapper, Margin.mt_5]}>
                    <View style={[Flex.alignCenter, Margin.mb_7, !helpers.isDesktop() && Margin.mb_4]}>
                        <View style={[Padding.ph_2, Helpers.titleBgWrap]}>
                            <View style={[Helpers.borderBottom]}>
                                <Text style={[Helpers.textCenter,Helpers.textUppercase, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, Margin.mb_0, {fontSize: 18},{fontFamily:FontFamily.regular}, {fontSize: helpers.isDesktop() ? 30 : 18} ]}>Stories for you</Text>
                            </View>
                        </View>
                        <View style={[Helpers.titleLine]}></View>
                    </View>                
                </View>
                <View style={[Margin.mt_3, helpers.isDesktop() && Margin.mb_4, Margin.ml_2, Margin.mr_2]}>
                    { helpers.isDesktop() ?
                    <ScrollContainerView horizontal={false} showsHorizontalScrollIndicator={false}>
                        <View style={[Flex.row, !process.browser && {overflow: 'hidden'}]}>
                            {data && data.map((item, index) => {
                                return (
                                    <View style={[articleItem.col3, helpers.isDesktop() && articleItem.col3Desktop]}>
                                        <ArticleItemUserStory viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} home={true}/>
                                    </View>
                                )
                            })}
                        </View>
                    </ScrollContainerView>
                    :
                    <ScrollContainerView horizontal={false}   showsHorizontalScrollIndicator={false}>
                        <View style={[Flex.column, !process.browser && {overflow: 'hidden'}]}>
                            {data && data.map((item, index) => {
                                return (
                                    <View style={[articleItem.col3, helpers.isDesktop() && articleItem.col3Desktop, {width: '100%'}]}>
                                        <ArticleItemUserStory viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} home={true}/>
                                    </View>
                                )
                            })}
                        </View>
                    </ScrollContainerView>
                }
                </View>
            </View>
        );
    }
}

export default AuthenticationWrapper(HomeStoriesForYou);
